import { render, staticRenderFns } from "./withholdIntegral.vue?vue&type=template&id=1a39b1a0&scoped=true"
import script from "./withholdIntegral.vue?vue&type=script&lang=js"
export * from "./withholdIntegral.vue?vue&type=script&lang=js"
import style0 from "./withholdIntegral.vue?vue&type=style&index=0&id=1a39b1a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a39b1a0",
  null
  
)

export default component.exports